import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { FaSpinner } from 'react-icons/fa';
import logo2 from '../../../img/logo.png';
import PhoneNumberInput from '../../PhoneNumberInput';

function RSVPForm() {
  const { id } = useParams();
  const cardId = id;
  const [name, setName] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [email, setEmail] = useState('');
  const [guests, setGuests] = useState('1');
  const [attending, setAttending] = useState(true);
  const [ucapan, setUcapan] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [emailEnabled, setEmailEnabled] = useState(1);
  const [selectedCountry, setSelectedCountry] = useState('US');
  const [localNumber, setLocalNumber] = useState('');
  const [imageFile, setImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);

  useEffect(() => {
    axios.get(`${process.env.REACT_APP_API_BASE_URL}/clients/${id}`)
      .then(response => {
        setEmailEnabled(response.data.email_input);
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    let imageUrl = '';
    if (imageFile) {
      const wpUsername = process.env.REACT_APP_WP_USERNAME;
      const wpAppPassword = process.env.REACT_APP_WP_APP_PASSWORD;
      const formData = new FormData();
      formData.append('file', imageFile);

      try {
        const wpRes = await axios.post(`${process.env.REACT_APP_PAY_BASE_URL}/wp-json/wp/v2/media`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'Authorization': 'Basic ' + btoa(`${wpUsername}:${wpAppPassword}`),
          },
        });

        if (wpRes.data && wpRes.data.source_url) {
          imageUrl = wpRes.data.source_url;

          await axios.post(`${process.env.REACT_APP_PAY_BASE_URL}/wp-json/wp/v2/media/${wpRes.data.id}`, {
            alt_text: 'invite_gallery'
          }, {
            headers: {
              'Authorization': 'Basic ' + btoa(`${wpUsername}:${wpAppPassword}`),
              'Content-Type': 'application/json',
            }
          });
        }
      } catch (error) {
        console.error('Error uploading image:', error);
      }
    }

    axios.post(`${process.env.REACT_APP_API_BASE_URL}/addrsvp`, {
      cardId,
      name,
      phoneNumber,
      email,
      guests: parseInt(guests),
      attending,
      ucapan,
      image_url: imageUrl,
      checkedIn: 0,
    })
    .then(response => {
      setMessage('RSVP confirmed!');
      setName('');
      setPhoneNumber('');
      setEmail('');
      setGuests('');
      setAttending(true);
      setSubmitted(true);
      setUcapan('');
      setImageFile(null);
      setImagePreview(null);
      setLoading(false);
    })
    .catch(error => {
      console.error('Error submitting RSVP:', error);
      setSubmitted(true);
      setLoading(false);
      setMessage('Error submitting RSVP. Please try again.');
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImageFile(file);
      setImagePreview(URL.createObjectURL(file));
    } else {
      setImageFile(null);
      setImagePreview(null);
    }
  };

  return (
    <div>
      {loading ? (
        <div className="fixed inset-0 flex flex-col items-center justify-center space-y-5">
          <FaSpinner className="text-4xl text-black animate-spin" />
          <img src={logo2} alt="Logo" className="h-12 mb-4" />
        </div>
      ) : submitted ? (
        <div className="max-w-lg mx-auto p-4">
          <div className="bg-green-200 text-green-800 py-2 px-4 rounded mb-4">
            {message}
          </div>
        </div>
      ) : (
        <div className="max-w-lg mx-auto p-4">
          <h2 className="text-2xl font-semibold mb-4">RSVP</h2>
          <form onSubmit={handleSubmit}>
            <div className="mb-4">
              <label className="block text-gray-700">Name:</label>
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} required className="w-full border rounded py-2 px-3" placeholder="Enter your full name" />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Phone Number:</label>
              <PhoneNumberInput
                selectedCountry={selectedCountry}
                localNumber={localNumber}
                onChangeCountry={setSelectedCountry}
                onChangeNumber={setLocalNumber}
                onPhoneNumberChange={(formatted) => setPhoneNumber(formatted)}
              />
            </div>
            {emailEnabled ? (
              <div className="mb-4">
                <label className="block text-gray-700">Email:</label>
                <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="w-full border rounded py-2 px-3" placeholder="Enter your email" />
              </div>
            ) : null}
            <div className="mb-4">
              <label className="block text-gray-700">No. of guests:</label>
              <input type="number" value={guests} onChange={(e) => setGuests(e.target.value)} required className="w-full border rounded py-2 px-3" placeholder="Enter number of guests" />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Attending?</label>
              <select value={attending} onChange={(e) => setAttending(e.target.value === 'true')} className="w-full border rounded py-2 px-3">
                <option value={true}>Attend</option>
                <option value={false}>Not attend</option>
              </select>
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Wishes:</label>
              <textarea value={ucapan} onChange={(e) => setUcapan(e.target.value)} className="w-full border rounded py-2 px-3" placeholder="Enter your wishes" />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700">Upload a Photo (optional):</label>
              <input type="file" accept="image/*" onChange={handleImageChange} className="w-full border rounded py-2 px-3" />
              {imagePreview && (
                <div className="mt-2">
                  <img src={imagePreview} alt="Preview" className="h-32 object-cover rounded" />
                </div>
              )}
            </div>
            <button type="submit" className="btn-primary py-2 px-4 rounded">Send RSVP</button>
          </form>
        </div>
      )}
    </div>
  );
}

export default RSVPForm;
